/* unplugin-vue-components disabled */import { render } from "./TextTag.vue?vue&type=template&id=3b3f8e70&scoped=true&ts=true"
import script from "./TextTag.vue?vue&type=script&lang=ts"
export * from "./TextTag.vue?vue&type=script&lang=ts"

import "./TextTag.vue?vue&type=style&index=0&id=3b3f8e70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3f8e70"]])

export default __exports__